import type { BannerImageComponent } from "../../types";
import { RuntimeImage } from "../../runtime/RendererRuntime";
import { getImageObjectPositionStyle, getImageOverrideProps, mergeClassNames, mergeStyles, resolveImageValue } from "../../utils/imageOptions";

/** Full-width banner image renderer with positioning options. */
export function BannerImageRenderer({ component }: { component: BannerImageComponent }) {
  const { src, alt, showLoadingCircle } = component.content;
  const { src: imageSrc, options } = resolveImageValue(src);
  const objectPositionStyle = getImageObjectPositionStyle(options);
  const overrideProps = getImageOverrideProps(options);
  return (
    <section>
      <RuntimeImage
        src={imageSrc}
        alt={alt}
        showLoadingCircle={showLoadingCircle === true || showLoadingCircle === "true"}
        className={mergeClassNames("w-full rounded-md ring-1 ring-black/10", overrideProps.className)}
        style={mergeStyles(objectPositionStyle, overrideProps.style)}
        priority
      />
    </section>
  );
}


